import { Modal, Switch } from 'antd';
import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { MdNavigateNext } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../../../api';
import MyPass from '../../../../../../assets/images/mypass.svg';
import { HEADERMENU_PATH } from '../../../../../../routes/RoutesURL';
import { RootState } from '../../../../../../store/rootReducer';
import HSButton from '../../../../../common/Button';
import LoginActions from '../../../../../login/redux/actions';

type Props = {
    isAI?: boolean;
};

const MyInfoModal: React.FC<Props> = ({ isAI }) => {
    const dispatch = useDispatch();

    const investorUUID = useSelector((state: RootState) => state.user.uuid);

    const [open, setOpen] = useState(false);
    const [income, setIncome] = useState(true);
    const [loader, setLoader] = useState(false);

    const onClickClose = () => {
        setOpen(false);
    };

    const onConfirm = () => {
        let type: 'setting' | 'onboarding' | undefined = undefined;
        if (window.location.pathname.includes(HEADERMENU_PATH.settings)) {
            type = 'setting';
        }
        if (window.location.pathname.includes(HEADERMENU_PATH.onboarding)) {
            type = 'onboarding';
        }
        dispatch(LoginActions.updateMyinfo(type));
        if (investorUUID) {
            setLoader(true);
            Apis.redirectToMyinfo(investorUUID, income)
                .then(({ data }) => {
                    window.location.href = data;
                })
                .catch(() => {
                    setLoader(false);
                });
        }
    };

    return (
        <>
            {isAI ? (
                <div
                    className="px-4 py-4 bg-white cursor-pointer flex justify-between items-center"
                    style={{ boxShadow: '5px 5px 10px 0px #0000001A' }}
                    onClick={() => setOpen(true)}
                >
                    <p className="WorkSans-Semibold text-[#20222B] font-semibold">
                        Complete via Singpass (
                        <img src={MyPass} alt="mypass" className="inline-block relative" />)
                    </p>
                    <MdNavigateNext color="#26AE60" size={'1.4rem'} />
                </div>
            ) : (
                <div className="flex justify-center items-center pt-8 pb-3">
                    <HSButton title="RETRIEVE MYINFO" type="primary" onClick={() => setOpen(true)} />
                </div>
            )}
            <Modal
                open={open}
                onOk={onConfirm}
                onCancel={onClickClose}
                closeIcon={<IoMdClose color="black" size={'1.3rem'} />}
                footer={null}
                centered
            >
                <div className="flex m-2 flex-col">
                    <p className="WorkSans color-182d4f text-lg mb-4">
                        Complete your KYC with Singpass (
                        <img src={MyPass} alt="myipass" className="inline-block relative -top-0.5" />)
                    </p>
                    <p className="text-sm text-gray-600 WorkSans">
                        Helicap is required to verify that you are an Accredited Investor. The more you share about
                        yourself, the more efficient and personalized your investment experience will be. What
                        information would you like to share with us?
                    </p>
                    <div>
                        <div className="flex justify-between items-center py-2">
                            <p>Personal Information</p>
                            <Switch defaultChecked disabled />
                        </div>
                        <div className="flex justify-between items-center py-2">
                            <p>Contact Information</p>
                            <Switch defaultChecked disabled />
                        </div>
                        <div className="flex justify-between items-center py-2">
                            <p>Income</p>
                            <Switch checked={income} onChange={(checked) => setIncome(checked)} />
                        </div>
                    </div>
                </div>
                <div className="p-2 flex justify-center items-center" id="onboarding">
                    <HSButton title="CONTINUE" onClick={onConfirm} type="primary" loading={loader} />
                </div>
            </Modal>
        </>
    );
};

export default MyInfoModal;
